import React from 'react'

function Loading() {
	return (
		<div className="z-50 fixed top-0 left-0 h-screen w-screen bg-white/50 flex justify-center items-center  ">
			<img
				src="https://d1crnb901o7gp8.cloudfront.net/static-group/images+/loader.png"
				alt=""
				className=" animate-spin w-12 h-12"
			/>
		</div>
	)
}

export default Loading
